import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';

@Component({
  selector: 'app-go-back-btn',
  templateUrl: './go-back-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: inline-block; }'],
})
export class GoBackBtnComponent {
  @Input() byHistory = false;
  @Input() urlSegments = 1;
  @Input() navigationExtras: NavigationExtras = { queryParamsHandling: 'merge', relativeTo: this.activatedRoute };

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly location: Location,
  ) {}

  goBack(urlSegments = this.urlSegments, byHistory = this.byHistory): void {
    if (byHistory) {
      this.location.back();
    } else {
      this.router.navigate(['../'.repeat(urlSegments)], this.navigationExtras);
    }
  }
}
